import { gql } from 'apollo-angular';
import { ADDRESS_GROUP_FIELDS_FRAGMENT } from "./address-group-definition";
import { DISCOUNT_GROUP_RELATION_DOCUMENT_BASE_FRAGMENT } from "./discount-group.definition";
import { DELETION_RESPONSE_FRAGMENT } from './system-definition';

export const DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION_FRAGMENT = gql`
fragment DiscountGroupCustomerGroupRelation on DiscountGroupCustomerGroupRelation {
    ...DiscountGroupRelationDocumentBase
    customerGroupId
    customerGroup {
        ...AddressGroupFields
    }
}
${DISCOUNT_GROUP_RELATION_DOCUMENT_BASE_FRAGMENT}
${ADDRESS_GROUP_FIELDS_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATIONS = gql`
query GetDiscountGroupCustomerGroupRelations($input:DiscountGroupCustomerGroupRelationSearchInput) {
    getDiscountGroupCustomerGroupRelations(input: $input) {
        totalItems
        items {
            ...DiscountGroupCustomerGroupRelation
        }
    }
}
${DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION = gql`
query GetDiscountGroupCustomerGroupRelation($id:String!) {
    getDiscountGroupCustomerGroupRelation(id: $id) {
        ...DiscountGroupCustomerGroupRelation
    }
}
${DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION_FRAGMENT}
`;


export const SAVE_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION = gql`
mutation SaveDiscountGroupCustomerGroupRelation($input: DiscountGroupCustomerGroupRelationInput!) {
    saveDiscountGroupCustomerGroupRelation(input: $input) {
        ... DiscountGroupCustomerGroupRelation
    }
}
${DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION_FRAGMENT}
`;

export const DELETE_DISCOUNT_GROUP_CUSTOMER_GROUP_RELATION = gql`
mutation DeleteDiscountGroupCustomerGroupRelation($id: String!) {
    deleteDiscountGroupCustomerGroupRelation(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;